import { render } from "./TestEditForm.vue?vue&type=template&id=53b1c246&scoped=true"
import script from "./TestEditForm.vue?vue&type=script&lang=js"
export * from "./TestEditForm.vue?vue&type=script&lang=js"

import "./TestEditForm.vue?vue&type=style&index=0&id=53b1c246&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b1c246"]])

export default __exports__